var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-terms-and-conditions"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-terms-and-conditions__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-terms-and-conditions__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ec6584","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-terms-and-conditions/page-terms-and-conditions.vue
// module id = SWC/
// module chunks = 0